import React from 'react';
import Css from './SaleItems.module.css';


function SaleItems({ fakprice, price, discont, saleprice }) {

  let discontsale;
  if (saleprice) {
    discontsale = Math.round(100 - saleprice * 100 / price);
    if(discontsale == 0){discontsale = null;}
  }
  let discont_ = Number(discont);
  return (
    <>
      {discont_ > 0 &&
        (
          <div className={Css.fakprice}>
            <span>
              -{discont_}%
            </span>

          </div>
        )
      }
      {!discont_ && discontsale &&  discontsale > 0 &&
        (
          <div className={Css.saleprice}>
            <span>
              -{discontsale}%
            </span>

          </div>
        )
      }
    </>
  );
}

export default SaleItems;